import { Spreadsheet, CollaborativeEditArgs } from '@syncfusion/ej2-spreadsheet';
import * as signalR from '@microsoft/signalr';
import { isNullOrUndefined } from "@syncfusion/ej2-base";

function CollaborateExcelApp() {
// For signalR Hub connection.
//const connection: signalR.HubConnection = new signalR.HubConnectionBuilder().withUrl('https://localhost:44385/hubs/spreadsheethub', {
const connection: signalR.HubConnection = new signalR.HubConnectionBuilder().withUrl('https://document.e-contentum.com/signalr/documenteditorhub', {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets
}).build();

let spreadsheet: Spreadsheet = new Spreadsheet({
    openUrl: 'https://services.syncfusion.com/js/production/api/spreadsheet/open',
    actionComplete: (args: {action: string, response: any}) => {
        if (args.action === 'import') {
            // Send the action data to the server in args.response at the time of importing an excel file.
            connection.send("BroadcastData", JSON.stringify(args.response.data));
        }
        else {
            // Send the action data to the server for other than import actions.
            connection.send("BroadcastData", JSON.stringify(args));
        }
    },
});

spreadsheet.appendTo('#spreadsheet');

connection.on('dataReceived', (data: string) => {
    const model: CollaborativeEditArgs = JSON.parse(
        data
    ) as CollaborativeEditArgs;

    // Condition to check whether action performed is import.
    if (isNullOrUndefined(model['action'])) {
        // Load the imported excel file data as JSON to the connected clients.
        const jsonData: object = { Workbook: model };
        spreadsheet.openFromJson({ file: jsonData });
    }
    else {
        // Update the action details to the connected clients.
        spreadsheet.updateAction(model);
    }
});
connection
    .start()
    .then(() => {
        console.log('server connected!!!');
    })
    .catch(err => console.log(err));


return (
    <div id='spreadsheet'></div>
)

}

export default CollaborateExcelApp;